export default __webpack_public_path__ + "static/media/avatar-mill.19225d74.svg";